<template>
	<div class="topUp">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onexport()">导出充值列表</el-button>
			<el-button type="primary" size="small" @click="onrechargeMethod()">充值</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.audit_state"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="rList" style="width: 100%" border height="100%">
					<el-table-column prop="trade_no" label="业务流水号" align="center" header-align="center" min-width="90px">
					</el-table-column>
					<el-table-column prop="amount" label="充值金额" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="pay_method_str" label="支付方式" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="account" label="收款账户" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="pay_account" label="付款账号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="pay_trade_no" label="流水号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="remark" label="备注" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="create_time_str" label="充值时间" align="center" header-align="center" width="100px">
					</el-table-column>
				</el-table>
			</div>

			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>


		<el-dialog title="充值" :visible.sync="dialogVisible" width="800px" :before-close="onclose">
			<div class="forms" v-if="dialogVisible">
				<el-form ref="form1" :model="form1" :rules="rules1" label-width="100px">
					<el-form-item label="支付方式" prop="pay_method">
						<el-radio-group v-model="form1.pay_method" @input="ontips">
							<el-radio :label="v.id" v-for="(v,k) in dataarr" :key="k">{{v.name}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="收款账户">
						<div>{{account}}{{bank}} <span style="padding-left: 20px;">姓名:{{name}}</span></div>
					</el-form-item>
					<el-form-item label="" v-if="qrcode">
						<div class="img">
							<img :src="qrcode">
						</div>
					</el-form-item>
					<el-form-item label="充值金额" prop="amount">
						<el-input v-model.number="form1.amount"></el-input>
					</el-form-item>
					<el-form-item label="付款账号" prop="pay_account">
						<el-input v-model="form1.pay_account"></el-input>
					</el-form-item>
					<el-form-item label="流水号">
						<el-input v-model="form1.pay_trade_no"></el-input>
					</el-form-item>
				</el-form>

				<div class="tips">
					<p v-for="(v,k) in tips" :key="k">{{v}}</p>
				</div>
			</div>
			<div class="fbtn">
				<el-button type="primary" @click="onprimary">充值</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'TopUp',
		data() {
			return {
				dataarr: [],
				tips: [],
				account: "",
				bank: "",
				name: "",
				qrcode: "",
				dialogVisible: false,
				page: 1,
				pageSize: 20,
				total: 0,
				rList: [],
				filtershow: true,

				formfilter: {
					state: '',
					mydate: [],
					btime: "",
					etime: "",
				},

				form1: {
					amount: "",
					pay_account: "",
					pay_trade_no: "",
					pay_method: ""
				},

				rules1: {
					amount: [{
							required: true,
							message: '请输入充值金额',
							trigger: 'blur'
						},
						{
							type: 'number',
							message: '充值金额必须为数字值'
						},
					],

					pay_account: [{
						required: true,
						message: '请填写付款账号',
						trigger: 'blur'
					}],

					pay_method: [{
						required: true,
						message: '请选择支付方式',
						trigger: 'change'
					}],
				}
			}
		},
		
		inject: ['appdata'],

		mounted() {
			// this.onrechargeMethod();
			this.onrechargeList();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			onfilter() {
				this.page = 1;
				this.onrechargeList();
			},
			
			onreset() {
				this.formfilter = {
					state: "",
					mydate: [],
					btime: "",
					etime: "",
				};
				this.page = 1;
				this.onrechargeList();
			},
			
			onrechargeMethod() {
				this.dialogVisible = true;
				this.$axios.get('api/user/recharge_method').then(res => {
					if (res.data.code == 0) {
						if (res.data.data.count != 0) {
							this.form1.pay_method = res.data.data.list[0].id;
							this.dataarr = res.data.data.list;
							this.ontips();
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onprimary() {
				this.$refs['form1'].validate((valid) => {
					if (valid) {
						this.$axios.post('api/user/recharge', this.form1).then(res => {
							if (res.data.code == 0) {
								this.$message.success('充值已提交，请联系客服审核。');
								this.onclose();
								this.onrechargeList();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			ontips() {
				this.dataarr.forEach((v, k) => {
					if (v.id == this.form1.pay_method) {
						if (v.tips) {
							this.tips = v.tips.split("\n");
							this.account = v.account;
							this.bank = v.bank;
							this.name = v.nickname;
							if (v.qrcode) {
								this.qrcode = v.qrcode;
							} else {
								this.qrcode = "";
							}

						}
					}
				})
			},

			onrechargeList() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/user/user_recharge_list', obj).then(res => {
					if (res.data.code == 0) {
						// if (res.data.data.count != 0) {
						this.total = res.data.data.count;
						this.rList = res.data.data.list;
						// }
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			handleCurrentChange() {
				this.onrechargeList();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onrechargeList();
			},

			onclose() {
				this.dialogVisible = false;
				this.form1 = {
					amount: "",
					pay_account: "",
					pay_trade_no: "",
					pay_method: ""
				};
			},
			
			onexport() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				this.$axios.post('/api/user/user_recharge_export', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.topUp {
		width: 100%;
		height: 100%;
	}

	.items {
		width: 100%;
		box-sizing: border-box;
		padding: 0 80px;
		margin-top: 40px;
	}

	.fbtn {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.tips {
		margin-top: 20px;
		font-size: 14px;
		line-height: 18px;
		position: absolute;
		right: 20px;
		bottom: 50px;
		color: #ff4714;
		line-height: 20px;
	}

	.img {
		width: 300px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.tablediv {
		height: 100%;
	}

	.forms {
		position: relative;

		/deep/ .el-input {
			width: 250px !important;
		}
	}
	
	.filterty .el-date-editor {
		width: 250px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/topUp.vue